<template>
    <div class="py-0">
        <div class="layout-box-sidebar">
            <div class="layout-box-sidebar-header">
                <slot name="title"></slot>
            </div>

            <div class="layout-box-sidebar-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts"></script>
